export default {
  apiBaseURLSocket: 'https://amableclaimprobe.com/',
  mrdRecipt: 'https://amableclaimprobe.com/',
  apiBaseURL: "https://amableclaimprobe.com/api",
  frontEndURL: "https://amableclaimprobe.com"
}

// export default {
//   apiBaseURLSocket: "https://stg-verifacto.amable.in",
//   mrdRecipt: 'https://stg-verifacto.amable.in/',
//   apiBaseURL: "https://stg-verifacto.amable.in/api" ,
//   frontEndURL: "https://stg-verifacto.amable.in"
// }

// export default {
//   apiBaseURLSocket: "http://172.16.16.39:3111",
//   mrdRecipt: 'http://172.16.16.39:3111/',
//   apiBaseURL: "http://172.16.16.39:3111/api" ,
//   frontEndURL: "http://172.16.16.39:3111"
// }
